import { render } from "./CharactersPage.vue?vue&type=template&id=15eba9be&scoped=true"
import script from "./CharactersPage.vue?vue&type=script&lang=js"
export * from "./CharactersPage.vue?vue&type=script&lang=js"

import "./CharactersPage.vue?vue&type=style&index=0&id=15eba9be&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15eba9be"]])

export default __exports__